import { render, staticRenderFns } from "./PressReleasesDetail.vue?vue&type=template&id=2066db93&scoped=true"
import script from "./PressReleasesDetail.vue?vue&type=script&lang=js"
export * from "./PressReleasesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066db93",
  null
  
)

export default component.exports